module.exports = __webpack_public_path__ + "img/fes6.924e69f0.png";